<script setup>
defineProps({
  label: { type: String, default: 'Loading' },
})
</script>

<template>
  <div class="wl-page-loader">
    <div class="wl-spinner" role="status" :aria-label="label" />
  </div>
</template>

<style scoped>
.wl-page-loader {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--brand-bg, #fff);
}
.wl-spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid var(--brand-border, #e5e7eb);
  border-top-color: var(--brand-primary, #6b7280);
  animation: wl-loader-spin 0.8s linear infinite;
}
@keyframes wl-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .wl-spinner {
    animation-duration: 2s;
  }
}
</style>
